<template lang="pug">
vm-row( class="data-master" vm-w="12")
  vm-col(vm-type="flex" vm-align="center" vm-lg=12 vm-sm=12)
    div
      h2 {{ $t('quotations.master_data') }}:
      span.description {{ $t('quotations.master_data_description') }}
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(vm-justify="left", vm-align="center", vm-w=4)
      b-form-group.div__quotation
        vm-select(autocomplete @change="clearSelectionBranch" :placeholder='$t("quotations.customer_placeholder")' :danger="$v.form.customer.$invalid && $v.form.customer.$model" :danger-text="$t('validation.required', { attribute: $t('quotations.customer') })" v-model="form.customer" :label='$t("quotations.customer")')
          vm-select-item(:key="index" :value="item" :text="item.name" v-for="(item,index) in customers")
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group.div__quotation
        vm-select(autocomplete :placeholder='$t("quotations.branche_placeholder")' v-model="form.branchIds" :label='$t("quotations.branche")')
          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in branches")
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group.div__quotation
        vm-button(class="div__quotation__button" icon="plus-outline" @click="addBranches") {{ $t('quotations.add_branche')}}
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group.div__quotation
        vm-input(:placeholder='$t("quotations.payment_conditions_placeholder")' v-model="form.payment_conditions" :label='$t("quotations.payment_conditions")')
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group.div__quotation
        vm-select(autocomplete multiple :placeholder='$t("quotations.requisite_placeholder")' v-model="form.requisitionersIds" :label='$t("quotations.requisite")')
          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in requisitioners")
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group.div__quotation
        vm-button(class="div__quotation__button" icon="plus-outline" @click="addRequisitionists") {{ $t('quotations.add_requisite')}}
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(vm-justify="left", vm-align="center", vm-w=4)
      b-form-group.div__quotation
        vm-input(:placeholder='$t("quotations.address_placeholder")' v-model="form.address" :label='$t("quotations.address")')
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group.div__quotation
        vm-select(autocomplete :placeholder='$t("quotations.contact_placeholder")' v-model="form.contact" :label='$t("quotations.contact")')
          vm-select-item(:key="index" :value="item" :text="item.name" v-for="(item,index) in contacts")
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
      b-form-group.div__quotation
        vm-button(v-if="form.customer !== undefined && form.customer !== null" class="div__quotation__button" icon="plus-outline" @click="addContact") {{ $t('quotations.add_contact')}}
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
        b-form-group
        label.vm-input--label {{ $t('quotations.tax_type') }}
        .radio-section
          .radio-item
            input.radio-margin(type="radio" value=0 id="tax_0" v-model="form.tax_type")
            label.radio-label(for="tax_0") 0%
          .radio-item
            input.radio-margin(type="radio" value=8 id="tax_8" v-model="form.tax_type")
            label.radio-label(for="tax_8") 8%
          .radio-item
            input.radio-margin(type="radio" value=16 id="tax_16" v-model="form.tax_type")
            label.radio-label(for="tax_16") 16%
    vm-col(vm-justify="center", vm-align="center", vm-w=4)
        b-form-group
        label.vm-input--label {{ $t('quotations.currency') }}
        .radio-section
          .radio-item(v-for='(currency, index) in currencies' :key="index")
            input.radio-margin(type="radio" :value="currency.id" :id="currency.id" v-model="form.currency_id")
            label.radio-label(:for="currency.id") {{ currency.code }}
    vm-col(vm-justify="left", vm-align="center", vm-w=4)
      b-form-group.div__quotation
        vm-input(v-if="form.currency_id === 2" v-model="form.exchange_rate" :label='$t("quotations.exchange_rate")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      vm-textarea(class="attached-custom__note" height="120px" :placeholder='$t("quotations.write_here")' :danger="$v.form.additional_conditions.$invalid && $v.form.additional_conditions.$model" :danger-text="$t('validation.lenght', { attribute: $t('quotations.additional_conditions') })" v-model="form.additional_conditions" @keyup.enter="setBullets(form.additional_conditions)" type="text" :label='$t("quotations.additional_conditions")')
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators' // Ver documentacion
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')
export default {
  name: 'QuotationMasterDataForm',
  mixins: [ViewMixinMaster1],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  validations () {
    return {
      form: {
        customer: {
          required
        },
        additional_conditions: {
          maxLength: maxLength(500)
        },
        tax_type: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['quotations', 'customers', 'contacts', 'currencies', 'requisitioners', 'branches'])
  },
  watch: {
    form: {
      handler (form) {
        this.$emit('onValidate', {
          valid: !this.$v.form.$invalid,
          step: 1
        })
      },
      deep: true
    },
    'form.customer' () {
      this.loadContactsCatalog(this.form.customer.id)
      this.loadBranchesCatalog({ page: `1&where_relation=${this.form.customer.id},customer.customer_id` }).then(() => {
      })
    },
    'form.currency_id' () {
      if (this.form.currency_id === 1) { this.form.exchange_rate = 1 }
    }
  },
  async created () {
    await this.loadCustomerCatalog()
    await this.loadRequisitionersCatalog({ page: 1 })
  },
  methods: {
    ...mapActions([
      'loadCustomerCatalog',
      'loadContactsCatalog',
      'loadRequisitionersCatalog',
      'loadBranchesCatalog',
      'setModalRequisitionersVisible',
      'setModalBranchesVisible',
      'setModalContactsVisible'
    ]),
    addRequisitionists () {
      this.setModalRequisitionersVisible(true)
    },
    addBranches () {
      this.$emit('modalBranches')
    },
    addContact () {
      this.setModalContactsVisible(true)
    },
    setBullets (payload) {
      const bullet = '•'
      this.form.additional_conditions = `${payload}${bullet} `
    },
    clearSelectionBranch () {
      this.form.branchIds = ''
    }
  }
}
</script>
<style lang="scss">
.data-master {
  .div__quotation {
    & button {
      margin-top: 20px;
      background: transparent !important;
      color: black;
      width: 100%;
      font-weight: 600;
      font-size: 12px;
      cursor: pointer;
      box-shadow: none;
      text-decoration: underline;
    }
  }
}
</style>
